import styled from 'styled-components';

const FloatingWrapper = styled.div`
  right: ${({ isDesktop }) => (isDesktop ? '3pt' : '3%')};
  margin-top: -2px;
  position: absolute;
  cursor: pointer;
  text-decoration: underline;
`;

export default FloatingWrapper;
